import React from "react";
import { Routes, Route } from "react-router-dom";
import Advance from "../Pages/Admin/Advances/Advance";
import AddAdvance from "../Pages/Admin/Advances/AddAdvance";
import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import AllEmployees from "../Pages/Admin/Employees/AllEmployees";
import Attendance from "../Pages/Admin/Employees/Attendance";
import AttendanceView from "../Pages/Admin/Employees/AttendanceView";
import EmployeePayDetailsAdd from "../Pages/Admin/Employees/EmployeePayDetails";
import EmployeePayView from "../Pages/Admin/Employees/EmployeePayView";
import EmployeePayoll from "../Pages/Admin/Employees/EmployeePayoll";
import Payroll from "../Pages/Admin/Employees/Payroll";
import Reports from "../Pages/Admin/Reports/Reports";
import Desigination from "../Pages/Admin/Settings/Desigination";
import Organization from "../Pages/Admin/Settings/Organization";
import Project from "../Pages/Admin/Settings/Project";
import Team from "../Pages/Admin/Settings/Team";
import TruckTripView from "../Pages/Admin/TruckTrip/TruckTripView";
import TruckTrip from "../Pages/Admin/TruckTrip/TruckTrip";
import PayslipGenerate from "../Pages/Admin/Reports/ReportPages/PayslipGenerate";
import EmployeeAttendance from "../Pages/Admin/Reports/ReportPages/EmployeeAttendance";
import DormitoryByUser from "../Pages/Admin/Reports/ReportPages/DormitoryByUser";
import EmployeePayDetailsDateRange from "../Pages/Admin/Reports/ReportPages/EmployeePayDetailsDateRange";
import PaySheetReport from "../Pages/Admin/Reports/ReportPages/PaySheetReport";
import AdvanceReportByDate from "../Pages/Admin/Reports/ReportPages/AdvanceReportByDate";
import TruckTripReport from "../Pages/Admin/Reports/ReportPages/TruckTripReportByDate";
import TeamMemberDetails from "../Pages/Admin/Reports/ReportPages/TeamMemberDetails";
const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/advance" element={<Advance />} />
      <Route path="/addAdvance" element={<AddAdvance />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/allEmployees" element={<AllEmployees />} />
      <Route path="/addAttendance" element={<Attendance />} />
      <Route path="/attendance" element={<AttendanceView />} />
      <Route path="/addEmployeePay" element={<EmployeePayDetailsAdd />} /> 
      <Route path="/viewEmployeePay" element={<EmployeePayView />} />
      <Route path="/payroll" element={<EmployeePayoll />} />
      <Route path="/payroll/generate" element={<Payroll />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/desigination" element={<Desigination />} />
      <Route path="/organization" element={<Organization />} />
      <Route path="/project" element={<Project />} />
      <Route path="/team" element={<Team />} />
      <Route path="/truckTrip" element={<TruckTripView />} />
      <Route path="/addTruckTrip" element={<TruckTrip />} />
      <Route path="/payslip" element={<PayslipGenerate />} />
      <Route path="/employeeAttendanceByMonth" element={<EmployeeAttendance />} />
      <Route path="/dormitoryByUser" element={<DormitoryByUser />} />
      <Route path="/employeePayDetailsDateRange" element={<EmployeePayDetailsDateRange />} />
      <Route path="/employeePaySheetReport" element={<PaySheetReport />}/>
      <Route path="/employeeAdavanceByDate" element={<AdvanceReportByDate />} />
      <Route path="/truckTripReport" element={<TruckTripReport />} />
      <Route path="/teamMemberDetails" element={<TeamMemberDetails />} />
    </Routes>
  );
}

export default AdminRoutes;